import { createContext } from 'react';

import { DatadogRumConfig } from './types';

export default createContext<DatadogRumConfig | null>(null);
